export const common = {
  'nav.home': 'Главная',
  'nav.about': 'О нас',
  'nav.services': 'Услуги',
  'nav.testimonials': 'Отзывы',
  'nav.info': 'Инфо',
  'nav.payment': 'Запись',
  'nav.logo': 'София & Елена',
  'nav.logoAria': 'На главную страницу',
  'nav.bookConsultation': 'Записаться',
  'nav.bookConsultationAria': 'Записаться на консультацию',
  'nav.changeLanguage': 'Сменить язык',
  'nav.language': 'Язык',
  'nav.openMenu': 'Открыть меню',
  'nav.closeMenu': 'Закрыть меню',

  'footer.brand': 'София & Елена',
  'footer.tagline': 'Эксперты в области нутрициологии и косметологии',
  'footer.navigation': 'Навигация',
  'footer.services': 'Услуги',
  'footer.contact': 'Контакты',
  'footer.vipSupport': 'VIP Сопровождение',
  'footer.fmdProtocol': 'Протокол FMD',
  'footer.childNutrition': 'Детская нутрициология',
  'footer.groupIntensive': 'Групповой интенсив',
  'footer.copyright': '© {{year}} София & Елена. Все права защищены.',
};